export default "__VITE_ASSET__5fb80024__"